import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const Subtitle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal[100]!,
    fontSize: `${pxToRem(14)} !important`,
    lineHeight: `${pxToRem(14)} !important`,
    textDecoration: 'underline !important',
    textTransform: 'none !important',
    textUnderlineOffset: pxToRem(2),
    ...theme.siteVariables.textStyles.Text.Roman55,
});

export const SubtitleWrapper: StyleRule = () => ({
    marginTop: pxToRem(5),
});

export const SlidesWrapper: StyleRule = () => ({
    marginBottom: pxToRem(36),
});

export const CaptionWrapper: StyleRule = () => ({
    padding: pxArrayToRem([8, 18, 0, 18]),
});
